/*
1. Check for user logged in (James)
-if not prompt to sign up (James)

2. Api call for current raffles (Jose)
-Check Shopify id for trendsetter (Jose) (are all accounts trendsetters?)
-Return points too (Jose)
--If not logged in prompt to sign up (James)

3. Display current raffles on front end (James)
-Only let you click raffles you have enough points for (James)

4. If store raffle return store list (Jose)
-Allow user to select stores (James)
--Call api on change to check if shoes can be guaranteed (Jose)
-Return if users can guarantee their shoe (Jose)

5. Allow user to choose size (James)

6. Allow user to choose kids size if applicable (James)

7. Add Slider allowing users to increase the amount of points being added (James)

8. Add ability to guarantee your pair (James)

9. Add checkbox for sms notifications (James)

10. Submit raffle form (James)
-Check before submission (Jose)
--Display any issues to the user (James)

11. Build form based on which raffle you choose (James)
*/

class RaffleList {

	logged_in = false;
	raffle;
	customer_id;
	raffle_list;
	raffle_container;
	raffle_page_elements;
	raffle_form;
	raffle_phone;
	raffle_trendsetter;
	raffle_title;
	raffle_image;
	user_coordinates = false;
	geocoder = false;
	has_stores_near = false;
	is_app = false;
	store_data;
	release_date;
	no_increased_chances = false
	device_id = '';
	user_agent = '';
	ip_address = '';
	worker_url = '';

	errors = {};
	errorList = {
		geo: 'Unable to determine your location. Please provide your zip code.',
		geocoder: 'Error trying to get zipcode location. Please refresh the page and try again.',
		geoZipcode: 'Error trying to locate zipcode. Please verify that the zipcode is correct.',
		blankZipCode: 'The zip code field cannot be blank. Please provide your zip code or use your location.',
		invalidZipCode: 'Invalid Zip Code.',
		invalidDistance: 'Invalid distance.',
		noStores: 'Please select at least one store.',
		maxStores: 'You may only select up to 4 stores per raffle.',
		invalidSubmission: 'Invalid submission. Verify that you only have a maximum of 4 stores selected.',
		uninitializedError: 'Error processing request. Please try again later',
		all: 'Reserved to clear all errors.'
	}

	status_list = {
		'200': "Registered successfully",
		'400': "Request body is malformed or has missing/wrong properties",
		'401': "User already registered",
		'403': "Illegal operation. Example, register before start date or after end date",
		'406': "Customer is not a trendsetter",
		'422': "Customer doesn't have enough points",
		'500': "Error inserting registration (server error)"
	};

	init() {

		console.log('initialize');

		this.raffle_list = $('.raffles-html');
		this.raffle_container = $('.raffle-page');
		this.raffle_trendsetter = $('.raffle-trendsetter-signup');
		this.raffle_phone = $('.raffle-phone-select');
		this.raffle_page_elements = $('.raffle-page-element');
		this.raffle_form = $('.raffle-form');
		this.raffle_title = $('.raffle-title');
		this.raffle_image = $('.raffle-image');

		this.init_back_button();
		this.init_refresh_button();
		this.get_raffles();
	}

	init_back_button(){
		let back_button = $('.raffle-page-back');
		let this_obj = this;
		if(!back_button.hasClass('init')){
			back_button.addClass('init');
			back_button.on('click', function(e){
				e.preventDefault();
				this_obj.raffle_page_elements.hide();
				this_obj.raffle_list.show();


				// let current_url = window.location.origin + window.location.pathname;
				// document.location = current_url;


			var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname;
			window.history.pushState({ path: newurl }, '', newurl);
			});
		}
	}

	get_raffles() {
		// get raffles via api call here

		let raffle_api_url = `${this.worker_url}/CustomerRaffle/Events/${this.customer_id}`;

		console.log(raffle_api_url);

		let this_object = this;

		$.ajax({
		  type: "GET",
          url: raffle_api_url,
          success: function (data) {
          	console.log("raffle data:");
          	console.log(data);

          	const filtered_phone_numbers = data?.verify_phone ? data?.verify_phone?.filter(number => number.phone != "9999999999") : false;

          	// let is_trendsetter = this_object.logged_in && data?.is_trendsetter && !data?.verify_phone ? true : false;
          	let is_trendsetter = this_object.logged_in && data?.is_trendsetter && (!data?.verify_phone || filtered_phone_numbers.length == 0) ? true : false;

          	if(this_object.logged_in &&
          		(
          			!data.is_trendsetter // || (data.verify_phone.length > 0 && filtered_phone_numbers.length == 0)
          		)
          	){
				this_object.raffle_page_elements.hide();
				this_object.raffle_trendsetter.show();
				this_object.raffle_list.hide();
				this_object.raffle_list.show();
          	}else if(this_object.logged_in && data.verify_phone && filtered_phone_numbers > 0){
          		this_object.build_phone_verification(data.verify_phone);
          	}else{
				this_object.raffle_list.show();
          	}

			this_object.build_raffles(JSON.parse(data.raffles), is_trendsetter);

			this_object.check_raffle_url();
          },
          error: function(XMLHttpRequest, textStatus, errorThrown) {

          	let raffle_html = `
	        	<div class="page-width error-loading-raffles">
	        		<h2 class="body-1">There was a problem loading raffles. Please wait a moment and try again.</h2>
	        		<a href="#" class="raffle-refresh btn full">Refresh Raffles</a>
				</div>
	        `;


			this_object.raffle_list.html(raffle_html);
			this_object.init_refresh_button();

		    console.log("Status Code: " + XMLHttpRequest.status);
		    console.log("Status: " + textStatus);
		    console.log("Error: " + errorThrown);

          }
        });
	}

	build_phone_verification(phone_numbers){

		console.log(phone_numbers);

		let phone_list = this.raffle_phone.find('.phone-number-list');

		let phone_html = '';
		let this_object = this;

		phone_numbers.forEach((number) => {
			phone_html += `<button class="btn primary full" data-guid="${number.guid}">${number.phone}</button>`;
		});

		phone_list.html(phone_html);

		this.raffle_phone.find('.phone-number-list button').on('click', function(){
			console.log($(this).data('guid'));
			let guid = $(this).data('guid');

			if(!phone_list.hasClass('loading')){

				let raffle_api_url = `${this_object.worker_url}/CustomerRaffle/SetPhone/${this_object.customer_id}/${guid}`;

				console.log(raffle_api_url);

				$.ajax({
				  type: "GET",
		          url: raffle_api_url,
		          success: function (data) {

					phone_list.removeClass('loadiing');
					this_object.refresh_raffle_list();

		   		  },
		     	  error: function(XMLHttpRequest, textStatus, errorThrown) {
					phone_list.removeClass('loadiing');

				    console.log("Status Code: " + XMLHttpRequest.status);
				    console.log("Status: " + textStatus);
				    console.log("Error: " + errorThrown);

		          }
		        });

			}
		});


		this_object.raffle_phone.show();
	}


	check_login(customer_id) {
		if(customer_id){
			this.logged_in = true;
			this.customer_id = customer_id;
			this.refresh_trendsetter_signup_link(customer_id);
		}else{
			this.logged_in = false;
			this.customer_id = '';
			this.refresh_trendsetter_signup_link(customer_id);
		}

		// Temporary testing logged in. Remove when done testing.
		// this.logged_in = true;
		// this.customer_id = this.get_customer_id();
	}


	refresh_trendsetter_signup_link(customer_id){

		if(!this.raffle_trendsetter)
			this.raffle_trendsetter = $('.raffle-trendsetter-signup');

		console.log("generate link");
		console.log(customer_id);

		let become_trensetter_btn = this.raffle_trendsetter.find('.become-trendsetter-btn');
		let link = `${become_trensetter_btn.data('link')}${customer_id ? '?customer=' + customer_id : '' }`;

		console.log(link);

		become_trensetter_btn.attr('href', link);
	}

	check_raffle_url(){
		var raffle_id = this.get_url_parameter('raffle_id');

		if(raffle_id && this.logged_in){

          	this.raffle_list.hide();
			this.get_raffle_form(raffle_id);
		} else if (raffle_id && !this.logged_in) {
			this.raffle_list.hide();
			const currentPath = window.location.pathname + window.location.search;
			window.location.href = "/account/login?redirect=" + encodeURIComponent(currentPath + (currentPath.includes('?') ? '&' : '?') + "raffle_id=" + raffle_id);
		}
	}

	get_url_parameter(sParam) {
	    var sPageURL = window.location.search.substring(1),
	        sURLVariables = sPageURL.split('&'),
	        sParameterName,
	        i;

	    for (i = 0; i < sURLVariables.length; i++) {
	        sParameterName = sURLVariables[i].split('=');

	        if (sParameterName[0] === sParam) {
	            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
	        }
	    }

	    return false;
	}

	build_raffles(raffles, is_trendsetter) {
		console.log('build raffles');
		let raffle_html = '';
		let login_html = '';
		let raffle_elements = '';

		if(!this.logged_in)
        	login_html = this.login_prompt();

        raffles.forEach(raffle => {
        	raffle_elements += this.build_raffle_html(raffle, is_trendsetter);
        });

        raffle_html += `
        	<div id="raffle-event-list-container" class="page-width">
        		${login_html}
        		<div id="raffle-event-list">
        			${raffle_elements}
			    </div>
			</div>
        `;


		$('.raffles-html').html(raffle_html);
		this.enable_raffle_links();
	}

	login_prompt() {
		return '<p class="raffle-login-prompt">You must be logged in to participate in trendsetter raffles.</p>';
	}

	build_raffle_html(raffle, is_trendsetter) {

        let raffle_element;
        let raffle_ended = false;
        let raffle_image = '';
        let raffle_image_class = '';
        let raffle_image_text = '';
        let raffle_link_class = '';
		let raffle_start_tag = `<a class="trandsetter_raffle ${!this.logged_in ? "login-prompt" : ""} ${is_trendsetter ? "eligable" : "ineligable"}" href="#" data-id="${raffle.id}">`;
        let raffle_end_tag = `</a>`;

        let raffle_time = new Date(raffle.end_date).toLocaleString();
        raffle_time = raffle_time.replace(':00 PM', " PM").replace(':00 AM', " AM")
		let raffle_time_html = `<div class="raffle-event-on-going">Ends on: ${raffle_time} EST</div>`;

		let raffle_type = 'DTLR Ecom And Store Raffle - Register Now!';

        let time = Date.now();
        // Temporary test data remove after
        // time = 1686051700337;
        // end test data

        if(time > raffle.end_date){
        	raffle_ended = true;
	        raffle_image_class = 'raffle-event-image-ended';
        	raffle_image_text = 'ENDED';
	        raffle_link_class = 'disabled';

		    raffle_start_tag = `<div>`;
        	raffle_end_tag = `</div>`;

        	raffle_time_html = `<div class="raffle-event-ended">Raffle ended on ${raffle_time} EST</div>`;
        }

        if (raffle.ecom && !raffle.store)
        	raffle_type = 'DTLR Ecom Raffle - Register Now!'
        else if (!raffle.ecom && raffle.store)
        	raffle_type = 'DTLR Store Raffle - Register Now!'

        raffle_image = raffle.img.replace('.jpg', '_600x600.jpg');

        raffle_element = `
    		<div class="raffle-event-block">
    			${raffle_start_tag}
    				<div class="raffle-event-image-container ${raffle_image_class}">
			            <div class="raffle-event-image" style="background-image: url('${raffle_image}');">
			                <span class="raffle-event-image-text-ended">${raffle_image_text}</span>
			            </div>
			        </div>
			        <div class="raffle-event-details">
			            <div class="raffle-event-title">${ raffle.title }</div>
			            <div class="raffle-event-location">${ raffle_type }</div>
			            ${raffle_time_html}
			        </div>
    			${raffle_end_tag}
    		</div>
        `;

        return raffle_element;
	}
	enable_raffle_links(){
		let this_object = this;
		$('.trandsetter_raffle.eligable').each(function(){
			let raffle = $(this);
			if(!raffle.hasClass('init')){
				raffle.addClass('init');
				raffle.on('click', function(e){
					e.preventDefault();
					if(this_object.logged_in){
						if(!$(this).hasClass('loading') && $(this).hasClass('eligable')){
							$(this).addClass('loading')
							this_object.get_raffle_form(raffle.data('id'), $(this));
						}
					}
				});
			}
		});

		$('.trandsetter_raffle.login-prompt').each(function(){
			let raffle = $(this);
			raffle.on('click', function(e){
				e.preventDefault();
				const currentPath = window.location.pathname + window.location.search;
				const loginUrl = "/account/login?redirect=" + encodeURIComponent(currentPath + (currentPath.includes('?') ? '&' : '?') + "raffle_id=" + raffle.data('id'));
				new swal({
					title: "Login Required",
					text: "Please sign in to your account to enter this raffle.",
					showCancelButton: true,
					confirmButtonColor: "#000",
					confirmButtonText: "Sign In",
					cancelButtonText: "Not Now"
				}).then((result) => {
					if (result.isConfirmed) {
						window.location.href = loginUrl;
					}
				});
			})
		});
	}

	get_raffle_form(raffle_id, raffle_link){
		console.log('show raffle');

		let raffle_api_url = `${this.worker_url}/CustomerRaffle/Event/${raffle_id}/${this.customer_id}`;
		let this_object = this;

		$.ajax({
		  type: "GET",
          url: raffle_api_url,
          success: function (data) {
          	// console.log("raffle data:");
          	// console.log(data);

          	raffle_link?.removeClass('loading');

          	this_object.raffle = data;

          	this_object.build_raffle_form();
			this_object.scroll_top_page();

			var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + `?raffle_id=${raffle_id}`;
			window.history.pushState({ path: newurl }, '', newurl);

          },
          error: function(XMLHttpRequest, textStatus, errorThrown) { 

          	raffle_link?.removeClass('loading');

          	if(XMLHttpRequest.status == 406){
	  			this_object.raffle_page_elements.hide();
				this_object.raffle_trendsetter.show();
				this_object.raffle_list.show();
          	} else if ( XMLHttpRequest?.responseJSON?.message == "Not a Trendsetter Rewards Member" ) {
				let raffle_html = `
					<div class="page-width error-loading-raffles">
						<h2 class="body-1">There was a problem loading raffles for your Trendsetter Account. Please contact customer service.</h2>
						<a href="/pages/customer-service" class="raffle-refresh btn full">Contact Us</a>
					</div>
				`;
				this_object.raffle_list.html(raffle_html);
	  			this_object.raffle_page_elements.hide();
				this_object.raffle_trendsetter.hide();
				this_object.raffle_list.show();
			}else if (XMLHttpRequest.status == 400){
				let raffle_html = `
	        	<div class="page-width error-loading-raffles">
	        		<h2 class="body-1">There was a problem loading raffles. Please wait a moment and try again. If this issue persists please contact customer service. </h2>
	        		<a href="#" class="raffle-refresh btn full">Refresh Raffles</a>
					<a href="/pages/customer-service" class="raffle-refresh btn full">Contact Us</a>
				</div>
				`;

				this_object.raffle_list.html(raffle_html);
				this_object.init_refresh_button();
			}else{
	          	this_object.raffle_list.show();
          	}

		    console.log("Status Code: " + XMLHttpRequest.status); 
		    console.log("Status: " + textStatus); 
		    console.log("Error: " + errorThrown); 

          }
        });
	}

	build_raffle_form = function(){

		console.log('Raffle Data');
		console.log(this.raffle);


		console.log(this.raffle.store_list);
		this.store_data = this.raffle.store_list;
		this.release_date = this.raffle.release_date;
		this.no_increased_chances = this.raffle.no_increased_chances;

		let raffle_form_html = '';

		raffle_form_html += `
			<div id="in-store-raffle" class="dtlr">
		        <h1 class="h3">${this.raffle.title}</h1>
		        <div class="desktop-flex">
		            <div class="raffle_banner flex-8">
		                <div class="hero" style="background-image:url('${ this.raffle.image }');">
		                </div>

		            </div>
		            <div class="raffle_content flex-4">
		                <div class="raffle_page_content">
		                	${ this.build_raffle_form_header() }
		                	<div class="raffle_page_content-body" id="raffle_page_body">
			                	${ this.build_raffle_form_element() }
			                    ${ this.build_raffle_form_store_element() }
			                    ${ this.no_increased_chances ? '' : this.build_raffle_form_points_element() }
			                    ${ this.build_raffle_form_contact_element() }
			                    ${ this.build_raffle_form_submit_element() }
			                    <div class="raffle_form_errors"></div>
		                    </div>
		                </div>
		            </div>
		        </div>
			</div>`;

		this.raffle_form.html(raffle_form_html);

		this.enable_raffle_form();
		this.enable_raffle_form_geo();

		this.raffle_page_elements.hide();
		this.raffle_container.show();
	}

	build_raffle_form_header(){

		let raffle_time = new Date(this.raffle.end_date).toLocaleString();
        raffle_time = raffle_time.replace(':00 PM', " PM").replace(':00 AM', " AM");

        let raffle_cutom_message = this.raffle.custom_message ? `<p class="body-2 raffle-custom-message">${this.raffle.custom_message}</p>` : ``;

		return `
			<div class="raffle-header">
				<p class="h4">Registration is Now Open until ${raffle_time}</p>
				<p class="body-2">
					Enter for your chance to purchase the ${this.raffle.title} in your size!
				</p>
				${raffle_cutom_message}
			</div>
		`;
	}

	build_raffle_form_element(){
		let raffle_form_elements_html = '';

		raffle_form_elements_html += this.build_raffle_form_size_element();

		return raffle_form_elements_html;
	}

	build_raffle_form_size_element(){
		let raffle_size_options = '';

		this.raffle.products.forEach(product => {
			console.log(product);
			let kids_sizing = product.kidsSizing ? product.kidsSizing : '';
			let product_size_options = '';
			let size_label = kids_sizing ? `${kids_sizing} Size` : `Size`;
			let size_id = kids_sizing ? `${product.styleNumber}-${kids_sizing.replace(' ', '-')}` : product.styleNumber;

			product.sizes.forEach(function(size){
				product_size_options += `<option value="${size}">${size}</option>`;
			});
			raffle_size_options += `
				<label class="raffle-size-label" for="${size_id}">${size_label}</label>
				<select id="${size_id}" class="raffle_size_select" data-style="${product.styleNumber}" data-kids="${kids_sizing}">
					<option selected disabled>Select A Size</option>
					${product_size_options}
				</select>
			`;
        });

		return `
			<div class="raffle_size_element">
				${raffle_size_options}
				<button class="btn primary full raffle_size_select_button">Select Size</button>
			</div>
		`;
	}

	build_raffle_form_store_element(){
		if(this.raffle.is_store){
			return `

				<div class="raffle_store_element" style="display:none;">

					<form class="clearfix" id="raffle_store_search">
		                <p class="body-2">
		                    To enter our store raffle, select to look up stores
		                    by your location or by entering your zip code below.
		                </p>


		                <div id="zip-code-container">
		                    <div class="zip-code input-box always-in-use">
		                        <label for="search_zipcode">Zip Code</label>
		                        <input
		                                type="text"
		                                id="search_zipcode"
		                                class="input-text"
		                                name="search_zipcode"
		                                minlength="5"
		                                maxlength="5"
		                                placeholder="Enter Zip Code"
		                        />
		                    </div>
		                </div>
		                <div class="search_miles input-box in-use">
		                    <label for="search_miles">Miles</label>
		                    <select name="miles" id="search_miles">
		                        <option value="5">5 Miles</option>
		                        <option value="10" selected>10 Miles</option>
		                        <option value="15">15 Miles</option>
		                        <option value="20">20 Miles</option>
		                        <option value="50">50 Miles</option>
		                    </select>
		                </div>

		                <div id="errors">
		                    <ul id="errorList"></ul>
		                </div>

		                <button id="search_stores_btn" class="btn btn-choose-option primary full" type="submit">
		                    Search Stores Near Me
		                </button>

		            </form>

		            <div class="fetching-stores d-none">
		                Loading stores...
		            </div>

		            <div id="store-list"></div>
		            <button class="btn primary full raffle_store_select_button" style="display: none;">Select Stores</button>
		        </div>
			`;
		}

		return '';
	}

	build_raffle_form_points_element(){

		let max_points = this.raffle.customer_points < 1000 ? parseInt(this.raffle.customer_points/100) * 100 : 1000;

		return `
			<div class="raffle_points_element" style="display:none;">
				<p class="body-2">You have: ${this.raffle.customer_points} Points<br>You can use Trendsetter Points to increase your odds. <b>Trendsetter Points will be returned if you do not win.</b></p>
				<div class="points-slider">
  					<input class="raffle_points_select" type="range" min="0" max="${max_points}" value="0" step="100" class="slider" id="myRange">
  					<output class="bubble"></output>
  				</div>
			</div>
		`;
	}

	enable_raffle_form(){
		this.enable_points_element();
		this.enable_select_size();
		this.enable_select_store();
		this.enable_submit_form();
	}

	enable_points_element(){
		let points_sider = this.raffle_form.find('.points-slider');
		let points_input = points_sider.find('.raffle_points_select');
		let points_output = points_sider.find('.bubble');

		points_output.each(function(){
			var value = $(this).prev().attr('value');
			$(this).html(value);
		});

		points_input.on('input', function(){
			$(this).next(points_output).html(this.value);
		});
	}

	build_raffle_form_contact_element(){
		return `
			<div class="raffle_contact_element" style="display:none;">
				<input class="raffle_contact_check" type="checkbox">
				<span class="raffle_contact_check-text body-2">Contact me by text if I am selected as a winner.</span>
			</div>
		`;
	}

	build_raffle_form_submit_element(){
		return `
			<div class="raffle_submit_element" style="display:none;">
				
				<a class="btn secondary full" href="https://www.instagram.com/dtlrofficial/" target="_blank" class="btn full">Follow Us on Instagram</a>
				<a class="btn secondary full" href="https://www.tiktok.com/@dtlrofficial?lang=en" target="_blank" class="btn full">Follow Us on TikTok</a>
					
				<form class="raffle_submit_form">
					<input class="btn primary full raffle_submit_button" type="submit" value="Enter Raffle" />
				</form>
			</div>
		`;
	}

	enable_raffle_form_geo() {
		if(this.raffle.is_store){
	        try {
	        	if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition((position)=>{this.geo_access_enabled(position)}, ()=>{this.geo_access_disabled()}, {timeout: 5000})
	    		} else {
					this.geo_access_disabled()
				}
	        } catch {
	          this.geo_access_disabled()
	        }
		}
	}

	geo_access_enabled(position) {

		if (position) {
			this.raffle_form.find('#zip-code-container').addClass('d-none');
			// removeError('geo')
			this.user_coordinates = {
				latitude: position.coords.latitude,
				longitude: position.coords.longitude
			};
			console.log(this.user_coordinates);

			this.store_query_by_location();

			let this_object = this;

			this.raffle_form.find('#raffle_store_search').on('submit', function(e){
				e.preventDefault();
				this_object.store_query_by_location();
			});

		} else {
			this.geo_access_disabled()
		}
	}

	geo_access_disabled() {

		console.log('no geo');
		// generateGeocoderScript()
		this.raffle_form.find('#zip-code-container').removeClass('d-none');
		this.userCoordinates = false;
		this.remove_error('all');
		this.throw_error('geo');
		this.error_handler();

		this.enable_geo_by_zip();
	}

	enable_geo_by_zip() {
		let raffle = this;
		let zip_input =  this.raffle_form.find('#search_zipcode');

		this.initGeocoder();

		this.raffle_form.find('#raffle_store_search').on('submit', function(e){
			e.preventDefault();

			// Temporary Code to work on local remove after
			/*raffle.user_coordinates = {
			    latitude: 39.8383777,
			    longitude: -74.9325683
			}
			raffle.store_query_by_location();
			return;*/
			// End Temporary Code to work on local

			let zipcode = zip_input.val();
			if(zipcode != null && zipcode.length == 5 && !isNaN(zipcode)){
				raffle.geocoder.geocode({'address': zipcode}, function (results, status) {
					if (status === google.maps.GeocoderStatus.OK) {
						raffle.user_coordinates = {
							latitude: results[0].geometry.location.lat(),
							longitude: results[0].geometry.location.lng()
						};

						raffle.store_query_by_location();

					} else {
						raffle.remove_error('all')
						raffle.throw_error('geoZipcode')
					}
				});

			}
			else if (zipcode != null)
				raffle.throw_error('blankZipCode');
			else
				raffle.throw_error('invalidZipCode');

		});
	}

	initGeocoder() {
		if (this.geocoder == false )
			this.geocoder = new google.maps.Geocoder()
	}

	store_query_by_location(){
		console.log('query store');
		console.log(this.user_coordinates);
		this.generate_store_list(this.raffle_form.find('#search_miles').val(), this.user_coordinates.latitude, this.user_coordinates.longitude);
	}

	error_handler() {
		var error = [];
		var tag = {open: '<li>', close: '</li>'};
		var errorList = tag.open;
		var errorListContainer = this.raffle_form.find('#errorList');

		if (this.errors && Object.keys(this.errors).length > 0 && this.errors.constructor === Object) {
			$.each(this.errors, function (k, v) {
				error.push(v);
			})

			errorList += error.join(tag.close + tag.open) + tag.close;

			errorListContainer.html(errorList);
		} else {
			errorListContainer.html('');
		}
	}

	throw_error(error) {
		if (this.errorList.hasOwnProperty(error)) {
			this.errors[error] = this.errorList[error];
		} else {
			this.errors.uninitializedError = this.errorList.uninitializedError;
		}

		// $('html, body').animate({scrollTop: retailStoreContainer.offset().top}, 500)

		this.error_handler();
	}

	remove_error(error) {
		if (error === 'all') {
			this.errors = {};
			this.error_handler();
		} else if (this.errors.hasOwnProperty(error)) {
			delete this.errors[error];
			this.error_handler();
		}
	}

	generate_store_list(searchMiles, latitude, longitude) {

		// console.log('store list');
		// console.log(this.store_data);

		this.remove_error('all')
		var storeHtml = ''
		var displayedStoresHtml = ''
		var renderedHtml = ''
		var allMatchedStores = []
		var maxRadius = 50
		var displayedStoresCount = 0
		var furthestStore = 0
		this.has_stores_near = false

		var this_object = this;


		$.each(this.store_data, function (k, v) {
			if(v){

				var distance = this_object.distance_calculator(v.Latitude, v.Longitude, latitude, longitude)
				var mills_location = v?.StoreType?.toLowerCase()?.includes('mills') ? true : false;
				var pickup_date = "";
				
				if (this_object.release_date)
					pickup_date = mills_location ? "<br><span style='color: #F83E54;'><b>Pickup Date:</b> " + new Date(this_object.release_date + 1209600000).toLocaleDateString() + "</span>" : "<br><span><b>Pickup Date:</b> " + new Date(this_object.release_date).toLocaleDateString() + "</span>";

				
				if (distance <= maxRadius) {
					storeHtml = ''
					storeHtml += '<div class="store-element_container">'
					storeHtml += '<input type="checkbox" name="choose_store" class="local-store set_default_store" data-store-number="' + v.Number + '" data-store-info="' + v.Name + ' - ' + v.City + ', ' + v.State + '" id="store-number-' + v.Number + '">'
					storeHtml += '<label class="choose-store_label" for="store-number-' + v.Number + '">'
					storeHtml += '<div class="choose-store_check"></div>'
					storeHtml += '<div class="choose-store_name">' + v.Name + '</div>'
					storeHtml += '<div class="choose-store_address store_address-inline">' + v.Address1 + '<br>' + v.City + ', ' + v.State + ', ' + v.ZipCode + pickup_date + '</div>'
					storeHtml += '<div class="choose-store_distance">' + distance + ' Miles</div>'
					storeHtml += '<div class="choose-store_address store_address-block">' + v.Address1 + '<br>' + v.City + ', ' + v.State + ', ' + v.ZipCode +  pickup_date + '</div>'
					storeHtml += '</label>'
					storeHtml += '</div>'

					allMatchedStores.push({html: storeHtml, distance: parseFloat(distance)})
				}
			}
		})

		var storeCount = allMatchedStores.length

		if (storeCount > 0) {
			this.has_stores_near = true

			allMatchedStores.sort(function (a, b) {
				return a.distance > b.distance ? 1 : -1
			})

			for (var store of allMatchedStores) {
				if (store.distance <= searchMiles || displayedStoresCount < 4) {
					displayedStoresHtml += store.html
					furthestStore = store.distance
					displayedStoresCount++
				}
			}
			var selectUpToText = displayedStoresCount <= 4 ? '' : ' You may select up to 4 store locations.'
			var closestStoresText = 'Showing the 4 closest stores.'
			var storeCountText = displayedStoresCount > 1 ? ' stores are' : ' store is'
			storeCountText = displayedStoresCount + storeCountText + ' accepting raffle entries within ' + searchMiles + ' miles.' + selectUpToText

			var displayText = furthestStore <= searchMiles ? storeCountText : closestStoresText

			renderedHtml += '<h3 class="choose-store_results_header body-1">' + displayText + '</h3>'
			renderedHtml += '<div class="choose-store_results_container">' + displayedStoresHtml + '</div>'

		} else {
			this.has_stores_near = false
			renderedHtml += '<h3 class="choose-store_results_header body-1">There is no in-store raffle event for this product within '
				+ searchMiles
				+ ' miles of your location</h3>'
		}

		this.raffle_form.find('#store-list').html(renderedHtml);
		this.enable_store_list();
	}

	enable_store_list(){
		let local_stores = this.raffle_form.find('.local-store');
		let this_object = this;

		local_stores.each(function(){
			let local_store = $(this);
			if(!local_store.hasClass('init')){
				local_store.addClass('init');
				var length = this_object.raffle_form.find('.local-store:checked').length
				// raffleTypeHandler();

				if (length === 4) {
					local_stores.not(':checked').attr('disabled', true)
				} else if (length > 4) {
					$(this).prop('checked', false)
					this_object.throw_error('maxStores')
				} else {
					this_object.remove_error('maxStores')
					local_stores.not(':checked').removeAttr('disabled')
				}

			}

			local_store.on('click', function () {
				var length = this_object.raffle_form.find('.local-store:checked').length;

				if (length === 4) {
					local_stores.not(':checked').attr('disabled', true);
				} else if (length > 4) {
					$(this).prop('checked', false)
					this_object.throw_error('maxStores')
				} else {
					this_object.remove_error('maxStores')
					local_stores.not(':checked').removeAttr('disabled')
				}


				if(length > 0)
					this_object.raffle_form.find('.raffle_store_select_button').show();
				else
					this_object.raffle_form.find('.raffle_store_select_button').hide();
			});
		});
	}

	distance_calculator(latitude1, longitude1, latitude2, longitude2) {
		if ((latitude1 === latitude2) && (longitude1 === longitude2)) {
			return 0
		} else {
			var radiusLatitude1 = Math.PI * latitude1 / 180
			var radiusLatitude2 = Math.PI * latitude2 / 180
			var theta = longitude1 - longitude2
			var radiusTetha = Math.PI * theta / 180
			var distance = Math.sin(radiusLatitude1) * Math.sin(radiusLatitude2) + Math.cos(radiusLatitude1) * Math.cos(radiusLatitude2) * Math.cos(radiusTetha)
			if (distance > 1) {
				distance = 1
			}
			distance = Math.acos(distance)
			distance = distance * 180 / Math.PI
			distance = distance * 60 * 1.1515
			return distance.toFixed(2)
		}
	}

	enable_submit_form(){

		let this_object = this;

		this_object.raffle_form.find('.raffle_submit_form').on('submit', function(e) {
			e.preventDefault();
			if(!$(this).prop("disabled"))
				this_object.submit_form(this);
		});
	}

	submit_form(form){


		$(form).prop( "disabled", true );
		this.set_form_errors(`<p class="body-2 form-loading" style="color: #242424">Submitting your entry, this may take a moment.</p>`);

		let form_values = {
			event_id: this.raffle.id,
			shopify_customer_id: this.customer_id,
			size: this.get_raffle_form_size_element(),
			selected_stores: this.get_raffle_form_store_element(),
			points_pledged: this.get_raffle_form_points_element(),
			sms_notification: this.get_raffle_form_contact_element(),
			ecom: this.raffle.is_ecom,
			disclaimer: 1,
			device_id: this.device_id,
			user_agent: this.user_agent,
			ip_address: this.ip_address
		}

		let enter_raffle_url = `${this.worker_url}/CustomerRaffle/Register`;

		let this_object = this;


		$.ajax({
		  type: "POST",
          url: enter_raffle_url,
          headers: {
    		"Content-Type": "application/json"
		  },
          data: JSON.stringify(form_values),
          success: function (data) {
          	console.log("entry data:");
          	console.log(data);

          	this_object.clear_form_errors();

          	this_object.raffle_success();
          },
          error: function(error) {

			console.log(error);

			let error_text = `<p>${error.responseJSON.message}</p>`;

			this_object.set_form_errors(error_text);

			$(form).prop( "disabled", false );

			/*

          	let error_text = "";
          	if (this_object.status_list.hasOwnProperty(XMLHttpRequest.status)) {
				error_text = this_object.status_list[XMLHttpRequest.status];
			} else {
				error_text = "Something went wrong, please try again.";
			}

			error_text = `<p>${error_text}</p>`;

			this_object.set_form_errors(error_text);


			$(form).prop( "disabled", false );

		    console.log("Status Code: " + XMLHttpRequest.status);
		    console.log("Status: " + textStatus);
		    console.log("Error: " + errorThrown);

		    */

		   }
        });

		console.log(form_values);
	}

	get_raffle_form_size_element(){

		let size_object = {};

		this.raffle_form.find('.raffle_size_select').each(function(){

			let raffle_size_element = $(this);

			if(raffle_size_element.val()){
				let size_name = raffle_size_element.data("kids") ? raffle_size_element.data("kids") : 'Size';

				size_object[size_name] = raffle_size_element.val();
			}
		});

		console.log(size_object);

		return size_object;
	}

	get_raffle_form_store_element(){

		let store_object = [];

		if(this.raffle.is_store){
			this.raffle_form.find('.local-store:checked').each(function() {
			    store_object.push($(this).data('store-number'));
			});

			store_object.join(',');
		}

		console.log(store_object);

		return store_object;
	}

	get_raffle_form_points_element(){
		if(this.no_increased_chances ||this.raffle.customer_points < 100)
			return 0;

		return this.raffle_form.find('.raffle_points_select').val();
	}

	get_raffle_form_contact_element(){
		return this.raffle_form.find('.raffle_contact_check:checked').length ? 1 : 0;
	}

	enable_select_size(){
		let size_button = this.raffle_form.find('.raffle_size_select_button');
		if(!size_button.hasClass('init')){
			size_button.addClass('init');
			size_button.on('click', () => {
				if(!jQuery.isEmptyObject(this.get_raffle_form_size_element())){
					this.raffle_form.find('.raffle_size_element').hide();
					if(this.raffle.is_store){
						this.clear_form_errors();
						this.raffle_form.find('.raffle_store_element').show();
						this.scroll_top_raffle();
					}else{
						this.clear_form_errors();
						this.raffle_form.find('.raffle_points_element').show();
						this.raffle_form.find('.raffle_contact_element').show();
						this.raffle_form.find('.raffle_submit_element').show();
						this.scroll_top_raffle();
					}
				}else{
					//Please select a size to continue
					this.set_form_errors('<p>Select at least one size to continue.</p>');

				}
			});
		}
	}

	set_form_errors(error){
		this.clear_form_errors();
		this.raffle_form.find('.raffle_form_errors').html(error);
	}

	clear_form_errors(){
		this.raffle_form.find('.raffle_form_errors').html('');
	}

	enable_select_store(){
		if(this.raffle.is_store){
			let store_button = this.raffle_form.find('.raffle_store_select_button');
			if(!store_button.hasClass('init')){
				store_button.addClass('init');
				store_button.on('click', () => {
					if(!jQuery.isEmptyObject(this.get_raffle_form_store_element())){
						this.raffle_form.find('.raffle_store_element').hide();
						this.raffle_form.find('.raffle_points_element').show();
						this.raffle_form.find('.raffle_contact_element').show();
						this.raffle_form.find('.raffle_submit_element').show();
						this.scroll_top_raffle();
					}else{
						this.throw_error('noStores');
					}
				});
			}
		}
	}
	enable_select_points_and_size(){}

	scroll_top_raffle(){
		$('html,body').animate({scrollTop: ($("#raffle_page_body").offset().top - 200) }, 200);
	}

	scroll_top_page(){
		$('html,body').animate({scrollTop: ($("#in-store-raffle").offset().top - 200) }, 200);
	}

	raffle_success(){
		let success_message = `<p class="body-2">Congratulations you have been entered to win the ${this.raffle.title} raffle! We will contact you by your preferred method if you win!</p><p><a href="https://www.instagram.com/dtlrofficial/" target="_blank" class="btn full">Follow Us on Instagram</a></p><p><a class="btn full" href="https://www.tiktok.com/@dtlrofficial?lang=en" target="_blank" class="btn full">Follow Us on TikTok</a></p>`;

		this.raffle_form.find('.raffle_page_content-body').html(success_message);

		this.scroll_top_raffle();
	}
	refresh_raffle_list(){
      // Refresh Current Raffle List Based On New Customer Object
	  this.raffle_page_elements.hide();
      this.raffle_list.show();
      this.get_raffles();
    }
    init_refresh_button(){
    	let this_object = this;
    	$('.raffle-refresh').each(function(){
    		if(!$(this).hasClass('init')){
    			$(this).addClass('init');
    			$(this).on('click', (e) => {
		    		e.preventDefault();
		    		this_object.refresh_raffle_list();
		    	});
    		}
    	});
    }
}
